import type transform from '../to/root-intervals';

export default (rootIntervals: ReturnType<typeof transform>) => {
  if (rootIntervals.length != new Set(rootIntervals.map(x => x.id)).size)
    throw new Error('(Core::From::V2::RootIntervals) RootInterval array have two or more root intervals with the same ID');

  return rootIntervals
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::RootIntervals) RootInterval id is undefined');

      return { ...x };
    });
};
